import { render, staticRenderFns } from "./StatisticsTableStat.vue?vue&type=template&id=f266f0f6&scoped=true"
import script from "./StatisticsTableStat.vue?vue&type=script&lang=js"
export * from "./StatisticsTableStat.vue?vue&type=script&lang=js"
import style0 from "./StatisticsTableStat.vue?vue&type=style&index=0&id=f266f0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f266f0f6",
  null
  
)

export default component.exports